// extracted by mini-css-extract-plugin
export default {"margins":"search_margins__z4irq","label_name":"search_label_name__CPWkH"};